import React from 'react';
import Section from './section';
import i18n from 'i18next';
import TextLoop from 'react-text-loop';
import { trackFootfallEventWithHrefDelay } from 'src/utils/analytics';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import { performSearch } from 'src/utils/router';

const words = [
  i18n.t('communities'),
  i18n.t('others like you'),
  i18n.t('experiences'),
  i18n.t('treatments'),
  i18n.t('answers'),
  i18n.t('emotional support'),
];

class SearchSection extends React.Component {
  render() {
    return (
      <Section withColumns={true}>
        <h2 className="home__input-title" >
          {i18n.t('Find')}
          {' '}
          <span className="home__search-word">
            <TextLoop speed={1500} adjustingSpeed={1000} >
              {words.map((word, i) => (
                <span key={`word-${i}`} >{word}</span>
              ))}
            </TextLoop>
          </span>
        </h2>
        <form
          className="home__long-form"
          onSubmit={e => {
            e.preventDefault();
            const searchTerm = this.searchBoxRef.value;
            performSearch(searchTerm);
          }}
        >
          <input
            className="form-control home__form-input"
            placeholder={i18n.t('What are you looking for?')}
            ref={node => this.searchBoxRef = node}
            type="text"
          />
          {' '}
          <button
            className="btn btn-primary btn-lg"
            type="submit"
          >
            {i18n.t('Search')}
          </button>
        </form>
      </Section>
    );
  }
}

export default SearchSection;



// WEBPACK FOOTER //
// ./src/modules/home/components/searchSection.js